import { UnitOfMeasureType } from '@app/models/item/enum/UnitOfMeasureType';

/** Maps a raw `UnitOfMeasureType` ordinal (Work Order's own UOM) to the unit Cuadraje/Balanceo display in. Falls back to 'lbs' for anything else. */
export function unitOfMeasureToDisplayUnit(uom: number | undefined | null): 'lbs' | 'yds' {
  return uom === UnitOfMeasureType.Yd ? 'yds' : 'lbs';
}
